import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ScrollingAppWrapper from "ScrollingAppWrapper";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import "./fonts.css";
import { AuthProvider } from "BEDROCK/auth/auth-provider";
import { NavigationBarProvider } from "navigation-bar/navigation-bar-provider";
import { AppScrollProvider } from "use-app-scroll";
import { Analytics } from "@vercel/analytics/react";
import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import { AnalyticsTracker } from "./analytics-tracker";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

amplitude.add(sessionReplayPlugin());
amplitude.init("c64ab46fc2c43190323258cb5b10a097", {
  autocapture: {
    attribution: true,
    fileDownloads: true,
    formInteractions: true,
    pageViews: true,
    sessions: true,
    elementInteractions: true,
    networkTracking: true,
    webVitals: true,
    frustrationInteractions: true,
  },
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsTracker />
      <QueryClientProvider client={queryClient}>
        <div className="container">
          <AuthProvider>
            <AppScrollProvider>
              <NavigationBarProvider>
                <div className="appContainer">
                  <ScrollingAppWrapper />
                </div>
              </NavigationBarProvider>
            </AppScrollProvider>
          </AuthProvider>
          <Analytics />
        </div>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
